import { useState } from "react";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Grid } from "@mui/material";
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { yellow } from '@mui/material/colors';
import Box from '@mui/material/Box';
import { AddCommentSharp } from "@mui/icons-material";


const Filter = ({ searchQuery, setSearchQuery, helper, setActive, addDataFunction, HideAddButton, HideActive }) => (

    <Grid container className="search-bar-container">
        <Grid item xs={12}>
            <Paper
                component=""
                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}>
                <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                    <SearchIcon />
                </IconButton>
                <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    value={searchQuery}
                    placeholder={helper}
                    onInput={(e) => { setSearchQuery(e.target.value); }}
                    inputProps={{ 'aria-label': 'search google maps' }}
                />

                {!HideActive ? <>                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                    <FormControlLabel control={<Switch onChange={setActive} defaultChecked />} label="Active" />
                    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" /></> : <></>}

                {!HideAddButton ?
                    <Box className="btn-add" >
                        <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={() => addDataFunction()}>
                            <AddIcon />
                        </IconButton>
                    </Box> : <></>}

            </Paper>
        </Grid>
    </Grid>
);


export default Filter;

